import { FC } from "react";
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { TextField } from "@mui/material";
import dayjs from 'dayjs';
import 'dayjs/locale/uk';
import { useTranslation } from "react-i18next";
import { tokens } from "../../locales/tokens";

dayjs.locale('uk');

interface IProps {
    size?: string;
    minDate?: Date;
    label?: string;
    isNotPast?: boolean;
    isDisabled?: boolean;
    value: number | null;
    handleDate: (date: Date | null) => void;
};

export const TimePicker: FC<IProps> = ({ handleDate, value, isDisabled, size, isNotPast, minDate, label }) => {
    const { t } = useTranslation();
    const time = value ? new Date(value) : null;

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
                disablePast={isNotPast}
                onChange={handleDate}
                value={time}
                disabled={isDisabled}
                minDate={minDate}
                renderInput={(props: any) =>
                    <TextField
                        variant="outlined"
                        fullWidth
                        color="primary"
                        {...props}
                        label={label || t(tokens.common.date)}
                        size={ size ? "small" : "medium"}
                    />
                }
            />
        </LocalizationProvider>
    )
};